// extracted by mini-css-extract-plugin
export default {"BirthdayPage":"styles_BirthdayPage__te2Ph","iframe":"styles_iframe__B-vXz"};